
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-municipals-26m-2019/catalunya",
      function () {
        return require("private-next-pages/3catinfo/eleccions-municipals-26m-2019/catalunya/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-municipals-26m-2019/catalunya"])
      });
    }
  